'use strict';

import { OwnershipService } from './ownership.service';

export default angular
	.module('mx.sb.Ownership', [
		/*'mx.shell'*/
	])
	.service('mx.sb.Ownership.OwnershipService', OwnershipService).name;
